/** 네 마을 스타일리스트 — 선택은 저장하고 다음 접속부터 몸에 적용한다. */
import { npcHead, muted, sec } from './common.js';

const ko = (gender) => gender === 'female' ? '여성' : '남성';
const valid = (gender) => gender === 'male' || gender === 'female';

export function render({ y }) {
  const current = valid(y.gender) ? y.gender : 'male';
  const stored = valid(y.inv?.appearanceGender) ? y.inv.appearanceGender : current;
  const pending = current !== stored;

  const focus = npcHead()
    + sec('외형 선택',
      `<div class="ux-facts"><div class="ux-fact"><span>현재 모습</span><b>${ko(current)}</b></div>`
      + `<div class="ux-fact"><span>다음 접속</span><b>${ko(stored)}</b></div></div>`
      + '<div class="ux-actions">'
      + `<button${stored === 'male' ? ' disabled' : ''} onclick="act.appearance('male')">남성</button>`
      + `<button${stored === 'female' ? ' disabled' : ''} onclick="act.appearance('female')">여성</button>`
      + '</div>'
      + (pending
        ? '<div class="row"><button class="wide" onclick="act.appearanceReload()">재접속해 적용</button></div>'
        : muted('선택한 외형이 적용되어 있다.'))
      + muted('선택을 저장하면 다음 접속부터 모습이 바뀐다.'));

  const guide = '<details class="ux-details" id="appearance-guide"><summary>외형 변경 안내</summary>' + muted(
    '근거리·원거리 직업, 레벨, 능력치, 장비와 아이템은 그대로다.<br>'
    + '스타일리스트에게서 언제든 외형을 다시 바꿀 수 있다.') + '</details>';
  return focus + guide;
}
